var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.545 10.182c.8 0 1.455.654 1.455 1.454V16c0 .8-.655 1.455-1.455 1.455H1.455C.655 17.455 0 16.8 0 16v-4.364c0-.8.655-1.454 1.455-1.454s1.454.654 1.454 1.454v2.91h10.182v-2.91c0-.8.654-1.454 1.454-1.454M5.687 6.429a1.45 1.45 0 0 1-2.058 0 1.45 1.45 0 0 1-.007-2.05L7.992 0l4.379 4.37c.567.568.574 1.492.007 2.06a1.45 1.45 0 0 1-2.058 0l-.873-.866v4.494a1.455 1.455 0 1 1-2.909 0V5.571z"
})));
export default SvgPinterestMobileShare;